import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core'
import { Router } from '@angular/router'
import { FormBuilder, Validators } from '@angular/forms'
import { LaunchDialogService, ICON_TYPE } from '@spartacus/storefront'
import { GlobalMessageType, GlobalMessageService } from '@spartacus/core'
import { SavedCartService } from '../saved-cart.service'
import { HttpParams } from '@angular/common/http'
import { CommonService } from '../../../../shared/services/common.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { PRE_URL } from '../../../../shared/constants'

@Component({
  standalone: false,
  selector: 'app-restore-saved-quote-cart-dialog',
  templateUrl: './restore-saved-quote-cart-dialog.component.html',
  styleUrls: ['./restore-saved-quote-cart-dialog.component.scss'],
})
export class RestoreSavedQuoteCartDialogComponent implements OnInit {
  iconTypes = ICON_TYPE
  modalIsOpen = false
  saveCartAsName = ''
  activeCartId = ''
  activeCartSize = null
  keepCopy = true
  dontSaveForLater = false
  nameError = false
  checkboxStatus = false
  duplicateErrorMessage = ''

  @Input() public currentUser: any = null

  @Input() public currentCart: any = null

  @Input() public sharedCartFlag: any = null

  @Input() public quoteCartFlag: any = null

  @ViewChild('dialog', { read: ElementRef })
  dialog: ElementRef

  restoreSavedCartForm = this.fb.group({
    keepCopy: [false],
    dontSaveForLater: [false],
    saveCartAsName: ['', Validators.required],
  })

  constructor(
    private launchDialogService: LaunchDialogService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private router: Router,
    private globalMessageService: GlobalMessageService,
    private savedCartService: SavedCartService
  ) {}

  ngOnInit() {
    this.launchDialogService.data$.subscribe((data) => {
      this.currentUser = data.currentUser
      this.currentCart = data.currentCart
      this.sharedCartFlag = data.sharedCartFlag
      this.quoteCartFlag = data.quoteCartFlag
    })
    this.loadAutoGenCartName()
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.RESTORE_SAVED_QUOTE_CART,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }

  loadAutoGenCartName() {
    this.commonService
      .getData(`${PRE_URL}/users/current/carts/current/autogeneratequotecartid`)
      .subscribe(
        (data: any) => {
          if (data?.code && data?.entries?.length) {
            this.saveCartAsName = data.code
            this.activeCartId = data.code
            this.activeCartSize = data.entries.length
            this.keepCopy = false
          } else {
            this.saveCartAsName = ''
            this.activeCartId = ''
            this.keepCopy = true
            this.activeCartSize = null
          }
        },
        (err) => {
          this.globalMessageService.add(
            {
              key: 'savedCart.cartNameFailed',
              params: {
                errorMsgJson: err.message,
              },
            },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  onSubmit() {
    let url
    let params = new HttpParams()
    if (this.activeCartSize > 0 && this.saveCartAsName.trim().length <= 0) {
      this.nameError = true
      return
    } else {
      this.nameError = false
    }
    if (this.sharedCartFlag == 'true') {
      const urlparams = ['users', this.currentUser.uid, 'vsrestoresharedcart']
      url = this.commonService.constructUrl(urlparams)
      params = params.append('cartId', this.currentCart.code)
      params = params.append('cartOwner', this.currentCart.savedBy.uid)
      params = params.append('isRfqCart', this.quoteCartFlag)
    } else if (this.sharedCartFlag == 'false') {
      const urlparams = [
        'users',
        'current',
        'carts',
        this.currentCart.code,
        'vsrestoresavedcart',
      ]
      url = this.commonService.constructUrl(urlparams)
      params = params.append('isRfqCart', this.quoteCartFlag)
    }
    if (this.dontSaveForLater) {
      //if the second checkbox is true,
      //then dnt save, send cartid and name as blank
      //this.activeCartId = ''
      //this.saveCartAsName = ''
    }
    this.commonService
      .patchData(
        url,
        {
          activeCartId: this.activeCartId,
          activeCartName: this.activeCartId,
          saveSavedCart: this.keepCopy,
          saveSessionCart: !this.checkboxStatus,
        },
        { params: params }
      )
      .subscribe(
        (res: any) => {
          let id = res.savedCartData.code
          sessionStorage.setItem('cartId-current', id)
          this.globalMessageService.add(
            {
              key: 'savedCart.cartRestoreSuccess',
              params: { cartName: this.currentCart.name },
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION,
            5000
          )
          setTimeout(() => {
            window.scrollTo(0, 0)
          }, 1500)
          this.dismissModal('Dismissing after successful restore')
          this.router.navigate(['/quote/cart'])
        },
        (err) => {
          let errorMsg = ''
          if (err.error?.errors[0]?.message == '101') {
            errorMsg =
              'You already have reached max. limit of saved carts. Please visit saved carts to remove saved carts if any'
            this.savedCartService.maxSavedCartErrorNotification.next(true)
            setTimeout(() => {
              this.savedCartService.maxSavedCartErrorNotification.next(false)
            }, 9000)
          } else if (err.error?.errors[0]?.message == '102') {
            this.duplicateErrorMessage = 'Cart name already exists'
          }

          if (errorMsg) {
            window.scroll(0, 0)
            this.dismissModal('Dismissing after successful restore')
          }
        }
      )
    return false
  }
  check_en(event) {
    if (event.target.checked) {
      this.checkboxStatus = true
    } else {
      this.checkboxStatus = false
    }
  }
}
